/**
 * The API base prefix, in its own module.
 *
 * It lived in api.ts, which is where it belongs conceptually — but auth.ts now
 * has to reach the auth endpoints itself (refresh, logout) and api.ts already
 * imports auth.ts. Importing back would be a cycle, and a cycle around a `const`
 * is the kind that bites at runtime rather than at build time: one of the two
 * modules sees the binding in its temporal dead zone and the base silently
 * becomes undefined. One tiny module both can import is cheaper than debugging
 * that once.
 */

// Prefer an explicit VITE_API_URL; otherwise fall back to the app's Vite base
// path (root '' by default — unchanged). The Mission Control playground serves
// the app under '/pgnd/priceq/' (Vite base), so the fallback resolves API calls
// to '/pgnd/priceq/api/...'. The empty-string check matters: the dev compose
// sets VITE_API_URL='' (not undefined), which '??' would keep.
const _viteApiUrl = import.meta.env.VITE_API_URL as string | undefined;

export const API_BASE =
  _viteApiUrl && _viteApiUrl.length > 0
    ? _viteApiUrl
    : import.meta.env.BASE_URL.replace(/\/$/, '');
